import { render } from "./ErrorMessageCase.vue?vue&type=template&id=372ab12c"
import script from "./ErrorMessageCase.vue?vue&type=script&lang=js"
export * from "./ErrorMessageCase.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__